/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audiencenotelabel2Inputs */

const en_audiencenotelabel2 = /** @type {(inputs: Audiencenotelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note for guests`)
};

const de_audiencenotelabel2 = /** @type {(inputs: Audiencenotelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis für Gäste`)
};

/**
* | output |
* | --- |
* | "Note for guests" |
*
* @param {Audiencenotelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const audiencenotelabel2 = /** @type {((inputs?: Audiencenotelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audiencenotelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audiencenotelabel2(inputs)
	return de_audiencenotelabel2(inputs)
});
export { audiencenotelabel2 as "audienceNoteLabel" }